import type { z } from "zod";

import type { Schema } from "./schema";
import { NUMBER_BY_DIRECTION } from "./sort";

import type { ListParams } from "~/shared/zod";
import { Pagination } from "~/shared/zod";

function mapListParams<FieldNames extends z.ZodEnum<[string, ...string[]]>>(
  { filter, sort, pagination }: ListParams.Schema<FieldNames>,
  mapOfFieldsToSortBy?: Record<z.infer<FieldNames>, string>,
): Schema<FieldNames> {
  return {
    filter,
    ...(sort && {
      sort: Object.entries(sort)
        .filter(
          (value): value is [FieldNames["options"][number], ListParams.Sort.Direction] =>
            typeof value[1] === "string",
        )
        .map(([selector, orderType]) => ({
          selector: mapOfFieldsToSortBy?.[selector] ?? selector,
          orderType: NUMBER_BY_DIRECTION[orderType],
        })),
    }),
    skip: Pagination.getNumberOfSkippedItems(pagination),
    take: pagination.size,
  };
}

export { mapListParams };
